export default {
  root: {
    display: 'block',
    fontSize: 20,
    marginBottom: 5,
  },
};
